import { render } from "./DropOrderPage.vue?vue&type=template&id=5e5592f0&scoped=true"
import script from "./DropOrderPage.vue?vue&type=script&lang=js"
export * from "./DropOrderPage.vue?vue&type=script&lang=js"

import "./DropOrderPage.vue?vue&type=style&index=0&id=5e5592f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5592f0"]])

export default __exports__